import { render, staticRenderFns } from "./BankReset.vue?vue&type=template&id=3781bf42&scoped=true&"
import script from "./BankReset.vue?vue&type=script&lang=js&"
export * from "./BankReset.vue?vue&type=script&lang=js&"
import style0 from "./BankReset.vue?vue&type=style&index=0&id=3781bf42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3781bf42",
  null
  
)

export default component.exports